import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormGroup,
  ValidatorFn
} from '@angular/forms';

declare let delta: any;

export class CustomValidator {
  static eitherFlightNumberOrAirportsValidator(c: AbstractControl) {
    const fromAirport = c.get('airports').get('fromAirport').value;
    const toAirport = c.get('airports').get('toAirport').value;
    const flightNumber = c.get('flightNumber').value;

    if (
      (fromAirport === undefined ||
        fromAirport === null ||
        fromAirport === '') &&
      (toAirport === undefined || toAirport === null || toAirport === '') &&
      (flightNumber === undefined ||
        flightNumber === null ||
        flightNumber === '')
    ) {
      return { eitherflightnumberorairports: true };
    }
    return null;
  }
}

export function validateFromAndToAirports(
  fromAirportControlName: string,
  toAirportControlName: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    const fromAirport = c.get(fromAirportControlName).value;
    const toAirport = c.get(toAirportControlName).value;
    if (
      (fromAirport === undefined ||
        fromAirport === null ||
        fromAirport === '') &&
      toAirport !== undefined &&
      toAirport !== null &&
      toAirport !== ''
    ) {
      return { fromrequired: true };
    }
    if (
      fromAirport !== undefined &&
      fromAirport !== null &&
      fromAirport !== '' &&
      (toAirport === undefined || toAirport === null || toAirport === '')
    ) {
      return { torequired: true };
    }
    if (!fromAirport || !toAirport) {
      return null;
    } else if (fromAirport === toAirport) {
      return { sameairports: true };
    } else {
      return null;
    }
  };
}

export function validateFromAndToAirportWithRequired(
  fromAirportControlName: string,
  toAirportControlName: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    const fromAirport = c.get(fromAirportControlName).value;
    const toAirport = c.get(toAirportControlName).value;
    if (
      (fromAirport === null ||
        fromAirport === undefined ||
        fromAirport === '' ||
        fromAirport.trim() === '') &&
      (toAirport === null ||
        toAirport === undefined ||
        toAirport === '' ||
        toAirport.trim() === '')
    ) {
      return { bothrequired: true };
    }
    if (
      (fromAirport === undefined ||
        fromAirport === null ||
        fromAirport.trim() === '') &&
      toAirport !== undefined &&
      toAirport !== null &&
      toAirport.trim() !== ''
    ) {
      return { fromrequired: true };
    }
    if (
      fromAirport !== undefined &&
      fromAirport !== null &&
      fromAirport.trim() !== '' &&
      (toAirport === undefined || toAirport === null || toAirport.trim() === '')
    ) {
      return { torequired: true };
    }
    if (fromAirport === toAirport) {
      return { sameairports: true };
    } else {
      return null;
    }
  };
}

export function validateFromAndToAirportsForBook(
  fromAirportControlName: string,
  toAirportControlName: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    const fromAirport = c.get(fromAirportControlName).value;
    const toAirport = c.get(toAirportControlName).value;
    if (
      (fromAirport === null ||
        fromAirport === undefined ||
        fromAirport === '' ||
        fromAirport.trim() === '') &&
      (toAirport === null ||
        toAirport === undefined ||
        toAirport === '' ||
        toAirport.trim() === '')
    ) {
      return null;
    }
    if (
      (fromAirport === undefined ||
        fromAirport === null ||
        fromAirport.trim() === '') &&
      toAirport !== undefined &&
      toAirport !== null &&
      toAirport.trim() !== ''
    ) {
      return null;
    }
    if (
      fromAirport !== undefined &&
      fromAirport !== null &&
      fromAirport.trim() !== '' &&
      (toAirport === undefined || toAirport === null || toAirport.trim() === '')
    ) {
      return null;
    }
    if (fromAirport === toAirport) {
      return { sameairports: true };
    } else {
      return null;
    }
  };
}

export function validatonAirport(c: AbstractControl) {
  const airport = c.value;
  if (airport === undefined || airport === null || airport.trim() === '') {
    return { required: true };
  }
  return null;
}

export function departureAndReturnDate(
  departureDate: string,
  returnDate: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    if (!c.get(departureDate).value && !c.get(returnDate).value) {
      return { bothrequired: true };
    }
    if (c.get(departureDate).value && !c.get(returnDate).value) {
      return { returndaterequired: true };
    }
    return null;
  };
}

export function onlyDepartureDate(departureDate: string): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    if (!c.get(departureDate).value) {
      return { required: true };
    }
    return null;
  };
}

export function validateMulticityDeptDate(
  formGroup: UntypedFormGroup,
  fn: number
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    const flights = <UntypedFormArray>formGroup.get('flights');
    let validatorFn = null;
    if (flights && flights.length > 1 && flights.controls[fn - 1]) {
      if (fn !== 1) {
        for (let i = 0; i < fn - 1; i++) {
          const dateOfPrevflight = new Date(
            flights.controls[i].get('departureDate').value
          );
          const dateToCompare = new Date(
            flights.controls[fn - 1].get('departureDate').value
          );
          if (dateToCompare.getTime() < dateOfPrevflight.getTime()) {
            validatorFn = { invalidflightdate: true };
            return validatorFn;
          }
        }
      }
      if (validatorFn === null && fn !== flights.length) {
        for (let i = fn; i < fn + 1; i++) {
          const dateValueToSet =
            flights.controls[fn - 1].get('departureDate').value;
          const oldDateValue = flights.controls[i].get('departureDate').value;
          if (oldDateValue !== '') {
            const dateToCompare = new Date(oldDateValue);
            const dateToSet = new Date(dateValueToSet);
            if (
              dateToSet.getTime() <= dateToCompare.getTime() ||
              dateValueToSet === ''
            ) {
              if (
                flights.controls[i]
                  .get('departureDate')
                  .hasError('invalidflightdate')
              ) {
                flights.controls[i].get('departureDate').setErrors(null);
              }
              return validatorFn;
            }
          }
          if (
            !flights.controls[i]
              .get('departureDate')
              .hasError('invalidflightdate') &&
            dateValueToSet !== ''
          ) {
            flights.controls[i].get('departureDate').setValue(dateValueToSet);
          }
        }
      }
    }
    return validatorFn;
  };
}

export function validateConnectionAndAirports(
  fromAirportControlName: string,
  toAirportControlName: string,
  connectionControlName: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    const fromAirport = c.get(fromAirportControlName).value;
    const toAirport = c.get(toAirportControlName).value;
    const connection = c.get(connectionControlName).value;
    if (!fromAirport || !toAirport || !connection) {
      return null;
    } else if (connection === fromAirport || connection === toAirport) {
      const fromerr = { sameasfromto: true };
      c.get(connectionControlName).setErrors(fromerr);
      return null;
    } else {
      return null;
    }
  };
}

export function validateAirportCode(control: AbstractControl) {
  const airportCode = control.value;
  if (airportCode && airportCode.length && control.parent) {
    const invalidAirportCodesCtr = control.parent.get('invalidAirportCodes');
    if (!invalidAirportCodesCtr) {
      return null;
    }
    const invalidAirportCodesStr: string = invalidAirportCodesCtr.value;
    if (!invalidAirportCodesStr || !invalidAirportCodesStr.length) {
      return null;
    }
    const invalidAirportCodes: string[] = invalidAirportCodesStr.split(',');
    const matchingIndex: number = invalidAirportCodes.findIndex(
      (value: string) => {
        if (value && value.length) {
          return (
            value.toUpperCase().trim() === airportCode.toUpperCase().trim()
          );
        } else {
          return false;
        }
      }
    );
    if (matchingIndex >= 0) {
      return { invalidairportcode: true };
    }
  }
  return null;
}

export function totalPaxCount(c: AbstractControl) {
  const pax = parseInt(c.value);
  let maxCount = c.parent.get('maxPaxCount').value;
  if (Number.isNaN(maxCount) || maxCount === undefined || maxCount === null) {
    maxCount = 9;
  }
  if (parseInt(c.value) > maxCount) {
    return { maxCount: true };
  }
  return null;
}

export function infantPaxCount(
  adultpax: string,
  infantpax: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    const adultCount = parseInt(c.parent.get(adultpax).value);
    const infantCount = parseInt(c.parent.get(infantpax).value);
    if (
      !Number.isNaN(infantCount) &&
      infantCount > 0 &&
      infantCount > adultCount
    ) {
      return { infantCount: true };
    }
    return null;
  };
}

export function adtPaxCount(adultpax: string): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } => {
    const adultCount = parseInt(c.parent.get(adultpax).value);
    if (!Number.isNaN(adultCount) && adultCount < 1) {
      return { adtCount: true };
    }
    return null;
  };
}
